import { Injectable } from '@angular/core';
import {
  GetUsersListCommand,
  IGetUsersListCommandParameters
} from './command/getUsersList.command';
import { MultiRegionService } from '../multiregion/multiregion.service';
import { ConnectionServices } from '../authentication/connection/connection.service';
import { SortEnum } from '../enum/sortEnum.enum';
import { UsersGrid } from '../authentication/connection/interfaces/apiInterfaces';
import { HttpErrorContainer } from '../authentication/connection/connection.service';
import { UsersListEnum } from '../enum/users-list.enum';
import {
  UpdateUserStatusCommand,
  IUpdateUserStatusCommandParameters
} from './command/updateUserStatus.command';
import { ISearchForEmailCommandParameters, ISearchForEmailCommandResponse, SearchForEmailCommand } from './command/searchForEmail.command';
import { Observable, map, throwError, catchError } from 'rxjs';
import { AlertService } from '../components/alerts/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from '../notifications/notifications.service';

@Injectable()
export class UsersListService {
  constructor(
    private _connectionService: ConnectionServices,
    private _alertService: AlertService,
    private _translateService: TranslateService,
    private _multiRegionService: MultiRegionService,
  ) {}

  public getUsersList(
    page: number,
    size: number,
    column: string,
    sort: SortEnum,
    find: string
  ): Observable<UsersGrid> {
    const command = new GetUsersListCommand();
    command.setParameters(<IGetUsersListCommandParameters>{
      column: column,
      page: page,
      size: size,
      sort: sort,
      find: find
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(data => {
          const response = data as UsersGrid;
          return response;
        }),
        catchError(error => {
          /*
          this._notificationsService.showHttpErrorMessage(
            'users',
            error
          );
          */
          return throwError(false);
        })
      )
  }

  updateUserStatus(userId: number, isActive: boolean) {
    const command = new UpdateUserStatusCommand();
    command.setParameters(<IUpdateUserStatusCommandParameters>{
      userId: userId,
      isActive: isActive
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(data => {
          /*
          this._notificationsService.showSuccessMessage(
            'toast.users.title',
            'toast.users.message.user_updated_status_success'
          );
          */
        }),
        catchError(error => {
          /*
          this._notificationsService.showHttpErrorMessage(
            'toast.users.title',
            error
          );
          */
          return throwError(false);
        })
      )
  }

  searchForExistingEmail(email: string, role: string, carrierId: number):Observable<ISearchForEmailCommandResponse> {
    const command = new SearchForEmailCommand();
    command.setParameters(<ISearchForEmailCommandParameters>{
      email: email,
      role: role,
      carrierId: carrierId
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(data => {
         /* this._notificationsService.showSuccessMessage(
            'toast.users.title',
            'toast.users.message.user_email_found'
          );*/
          return data;
        }),
        catchError(error => {
          let message = 'toast.users.message.error_while_finding_email';
          if(error.status == 409){
            if(error.error.errorCode == "MAIL_UNIQUE"){
              console.log("MAIL_UNIQUE");
              message = 'toast.users.message.error_mail_unique';
            }else if(error.error.errorCode == "USER_ALREADY_EXIST"){
              console.log("USER_ALREADY_EXIST");
              message = 'toast.users.message.error_user_already_exist';
            }
          }
          this._alertService.alertWarning(
            this._translateService.instant('toast.users.message.attention'),
            this._translateService.instant(message),
            false
          );
          return throwError(false);
        })
      )
  }
}

